// Notee教材（書き込み式教材）を他のデジタル教材と区別するためのラベル。
// 教材名の直後に置く想定のため、左マージンを内包している。
export const NoteeLabel = () => {
  return (
    <span className="ml-[0.8rem] inline-flex items-center rounded bg-blue-200 px-[0.8rem] py-[0.5rem] align-middle text-xs font-bold leading-none text-blue-400">
      Notee教材
    </span>
  );
};
